import { ColumnProps } from "antd/lib/table";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import OrderNoteContext from "../../../context/order-note/context";
import { IOrderNote } from "../../../models/order-note/response";
import Space from "../../general/antd/space";
import ViewBtn from "../../general/table-components/actions/view-btn";
import { ISort, IStaticFilter } from "../../../models/base/base-query";
import { tableOnChange } from "../../../utils/helpers/table-sorts-filters";
import Table from "../../general/table-components/table";
import styles from './styles.module.scss';

interface IProps { }

const OrderNoteTable: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { list, actions, loading, query } = useContext(OrderNoteContext);

  const columns: ColumnProps<IOrderNote>[] = [
    {
      title: t("id"),
      dataIndex: "id",
      key: "id",
      sorter: {
        multiple: 1,
      },
      width: 100,
      align: "center",
    },
    {
      title: t("text"),
      dataIndex: "text",
      align: "center",
      key: "text",
      minWidth: 200,
      sorter: {
        multiple: 2,
      },
    },
    {
      title: t("note"),
      dataIndex: "note",
      align: "center",
      key: "note",
      render: (_, recod) => {
        return recod?.note ? recod?.note : "-";
      },
    },
    {
      title: t("actions"),
      width: 250,
      dataIndex: "",
      align: "center",
      key: "x",
      render: (_: any, record) => (
        <Space>
          <ViewBtn
            onClick={(e) => {
              const url = `/order-note/details/${record?.id}`;
              if (e.ctrlKey || e.metaKey) {
                window.open(url, "_blank");
              } else {
                navigate(url);
              }
            }}
          />
          {/* <EditBtn
            onClick={(e) => {
              const url = `/order-note/update/${record?.id}`;
              if (e.ctrlKey || e.metaKey) {
                window.open(url, "_blank");
              } else {
                navigate(url);
              }
            }}
          />
          <DeleteBtn
            onConfirm={async () => {
              await actions.deleteOrderNote(record?.id);
              eventManager.emit(EVENT_SUCCESS);
            }}
            loading={loading.includes("delete")}
          /> */}
        </Space>
      ),
    },
  ];

  // Filters && Sorts
  let tableFiltersProps = {};
  const [sorts, setSorts] = useState<ISort[]>([]);
  const [, setStaticFilters] = useState<IStaticFilter[]>(query?.filters ?? []);

  useEffect(() => {
    sorts.length > 0 &&
      actions.setQuery({
        ...query,
        orders: sorts,
      });
  }, [sorts]);

  return (
    <>
      <Table<any>
        rowKey="id"
        showPagination={true}
        columns={columns}
        dataSource={list?.data ?? []}
        loading={loading.includes("list") || list == undefined}
        size="small"
        total={list?.total}
        pageSize={query.perPage}
        className={styles.table}
        page={query.page}
        onPaginationChange={(page, pageSize) => {
          actions.setQuery({
            ...query,
            page,
            perPage: pageSize,
          });
        }}
        onChange={(_, tableFilters, tabelSorters) => {
          tableOnChange(
            tableFilters,
            tabelSorters,
            tableFiltersProps,
            setSorts,
            setStaticFilters
          );
        }}
      />
    </>
  );
};

export default OrderNoteTable;
